/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".template1[_ngcontent-%COMP%]   .content-message[_ngcontent-%COMP%]{font-family:scriptorama-tradeshow-jf;line-height:initial;font-size:5rem;margin-top:5rem;-webkit-transform:rotate(-15deg);transform:rotate(-15deg)}.template1[_ngcontent-%COMP%]   .font-regular-weight[_ngcontent-%COMP%]{font-weight:400!important}"];
export { styles as styles };
